enum DeliveryChannel {
    Undefined = "Undefined",
    WorkEmail = "WorkEmail",
    Slack = "Slack",
    MsTeams = "MsTeams",
    PersonalEmail = "PersonalEmail",
    Sms = "Sms"
}

export default DeliveryChannel;